import { graphql } from 'react-relay/legacy';

export type {
    pdpRespMarketplaceSecondaryRootQuery$variables,
    pdpRespMarketplaceSecondaryRootQuery as pdpRespMarketplaceSecondaryRootQueryType,
} from './__generated__/pdpRespMarketplaceSecondaryRootQuery.graphql';

export const pdpRespMarketplaceSecondaryRootQuery = graphql`
    query pdpRespMarketplaceSecondaryRootQuery(
        $itemId: String!
        $isTrade: Boolean!
        $itemIds: [String]!
        $fetchUser: Boolean!
        $guestId: String = ""
        $userId: String = ""
        $priceBookName: String = ""
        $afterDisplay: Boolean = false
        $afterDisplayAndNotBot: Boolean = false
        $personalizationId: String = ""
        $userCountryCode: String = ""
        $fetchSellerReviewsSection: Boolean = false
        $isEstimateSimilarSoldVariant: Boolean = false
    ) {
        viewer {
            ...PdpRespMarketplaceLayoutSecondaryRefetchContainer_viewer
        }
    }
`;
